module.exports = __webpack_public_path__ + "img/card-s.6d3bf991.png";